import { useEffect, useRef, useState } from 'react';

function useWidth() {
  const ref = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<number>(0);
  useEffect(() => {
    const getWidth = () => {
      if (ref.current) {
        const { offsetWidth } = ref.current;
        setWidth(offsetWidth);
      }
    };
    getWidth();
    window.addEventListener('resize', getWidth);
    return () => window.removeEventListener('resize', getWidth);
  }, []);
  return {
    width, ref,
  };
}

export default useWidth;
